// eslint-disable-next-line import/prefer-default-export
export var toType = function toType(a) {
  return {}.toString.call(a).match(/([a-z]+)(:?\])/i)[1];
};